var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0641 13.5859C22.2119 12.5907 21.8246 11.7282 21.8246 10.263V9.76483C21.8246 7.85547 21.3851 6.62525 20.4297 5.39503C18.9571 3.4845 16.4781 2.33301 14.0513 2.33301H13.9481C11.5723 2.33301 9.17092 3.43162 7.67284 5.26461C6.66523 6.5195 6.17475 7.80259 6.17475 9.76483V10.263C6.17475 11.7282 5.81299 12.5907 4.93524 13.5859C4.2894 14.3191 4.08301 15.2614 4.08301 16.2813C4.08301 17.3024 4.4181 18.2694 5.09062 19.0555C5.96836 19.9978 7.20787 20.5994 8.47405 20.704C10.3072 20.9131 12.1404 20.9919 14.0003 20.9919C15.8589 20.9919 17.6921 20.8603 19.5265 20.704C20.7915 20.5994 22.031 19.9978 22.9087 19.0555C23.5801 18.2694 23.9163 17.3024 23.9163 16.2813C23.9163 15.2614 23.7099 14.3191 23.0641 13.5859Z",
    fill: "#FF5C5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3431 22.4323C15.7598 22.3077 12.2059 22.3077 11.6227 22.4323C11.1241 22.5474 10.585 22.8153 10.585 23.4028C10.6139 23.9633 10.9421 24.458 11.3966 24.7717L11.3955 24.7729C11.9833 25.2311 12.6732 25.5225 13.3956 25.6271C13.7806 25.68 14.1725 25.6776 14.5713 25.6271C15.2926 25.5225 15.9825 25.2311 16.5703 24.7729L16.5692 24.7717C17.0237 24.458 17.3518 23.9633 17.3808 23.4028C17.3808 22.8153 16.8417 22.5474 16.3431 22.4323Z",
    fill: "#FF5C5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.ceaed1eaa174577bfbcbec67dbf8df91.svg";
export { ForwardRef as ReactComponent };